import { createRestSlice } from "./restSlice";

export type ReleaseStatus = "pending" | "released" | "failed";

export type Release = {
  id: string;
  organizationId: string;
  agentId: string;
  environmentId: string;
  functionId?: string;
  userId: string;
  status: ReleaseStatus;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const releaseSlice = createRestSlice<Release>("release", "/v1/releases");

export const releaseReducer = releaseSlice.reducer;
export const releaseActions = releaseSlice.actions;
